import { useQuery } from "@tanstack/react-query";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "@/components/modals/BaseModal";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { TablaOFsModal } from "./TablaOFs";

interface ModalOFsProps extends BaseModalProps { readonly xconjunto_id: string | null; }
export function ModalOFs(props: ModalOFsProps) {
	return (
		<BaseModal show={props.show} close={props.close} minWidth="60%">
			<div className="modal-header">
				<h4 className="modal-title">Ordenes de fabricación</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<div className="table-responsive">
					{props.xconjunto_id != null && (
						<TablaOFsModal xconjunto_id={props.xconjunto_id} />
					)}
				</div>
			</div>

			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
			</div>
		</BaseModal>
	);
}

export interface OrdenesConjuntoParams {
	xconjunto_id: string;
}
export function useOrdenesConjunto(params: OrdenesConjuntoParams) {
	return useQuery<OrdenConjunto[]>({
		queryKey: ["getOrdenesConjunto", { idConjunto: params.xconjunto_id }],
		queryFn: () => sendAjaxRequest("GET", "/api/v1/getOrdenesConjunto", params),
	});
}
export type OrdenConjunto = Record<string, string>;